/* VEYRA v3.1 · hareket katmanı */
(() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* 1. Scroll reveal */
  const auto = [
    ['.v-tile', 90], ['.v-why__c', 80], ['.v-step', 110], ['.v-icons__it', 70],
    ['.multicolumn-card', 90], ['.collapsible-content .accordion', 50],
    ['.image-with-text__content', 0], ['.featured-product .product__info-wrapper', 0],
    ['.v-tiles__head', 0], ['.title-wrapper-with-link', 0], ['.collapsible-content__header', 0]
  ];
  auto.forEach(([sel, step]) => {
    const groups = new Map();
    $$(sel).forEach(el => {
      const p = el.parentElement; const i = groups.get(p) || 0; groups.set(p, i + 1);
      el.classList.add('v-rv'); el.style.setProperty('--d', (i * step) + 'ms');
    });
  });
  $$('.image-with-text__media, .featured-product .product__media-wrapper').forEach(el => el.classList.add('v-rv--img'));
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px', threshold: .12 });
  $$('.v-rv, .v-rv--img').forEach(el => RM ? el.classList.add('is-in') : io.observe(el));

  /* 2. Header gölge */
  const onScroll = () => document.body.classList.toggle('v-scrolled', scrollY > 40);
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* 3. Sinematik hero */
  $$('[data-vh]').forEach(root => {
    const slides = $$('[data-vh-slide]', root), dots = $$('[data-vh-dot]', root);
    if (slides.length < 2) return;
    const ms = (+root.dataset.speed || 6) * 1000; root.style.setProperty('--vh-speed', ms / 1000 + 's');
    let i = 0, t;
    const go = n => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-on', k === i));
      dots.forEach((d, k) => { d.classList.remove('is-on'); if (k === i) { void d.offsetWidth; d.classList.add('is-on'); } });
      clearTimeout(t); if (!RM && !root.classList.contains('is-paused')) t = setTimeout(() => go(i + 1), ms);
    };
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    root.addEventListener('mouseenter', () => { root.classList.add('is-paused'); clearTimeout(t); });
    root.addEventListener('mouseleave', () => { root.classList.remove('is-paused'); go(i); });
    let x0 = null;
    root.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', e => {
      if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1));
    });
    document.addEventListener('visibilitychange', () => document.hidden ? clearTimeout(t) : go(i));
    go(0);
  });

  /* 4. Hikâye: aktif bölüm + ilerleme */
  $$('[data-vs]').forEach(root => {
    const chs = $$('[data-vs-ch]', root), imgs = $$('[data-vs-img]', root);
    const num = root.querySelector('[data-vs-num]'), prog = root.querySelector('[data-vs-prog]');
    const set = n => {
      chs.forEach((c, k) => c.classList.toggle('is-on', k === n));
      imgs.forEach((c, k) => c.classList.toggle('is-on', k === n));
      if (num) num.textContent = String(n + 1).padStart(2, '0');
    };
    const cio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) set(+e.target.dataset.vsCh); }),
      { rootMargin: '-45% 0px -45% 0px' });
    chs.forEach(c => cio.observe(c));
    if (prog) {
      const wrap = root.querySelector('.vs__chs');
      const upd = () => {
        const r = wrap.getBoundingClientRect(), h = r.height - innerHeight * .5;
        const p = Math.min(1, Math.max(0, (innerHeight * .5 - r.top) / h));
        prog.style.transform = `scaleX(${p})`;
      };
      addEventListener('scroll', upd, { passive: true }); upd();
    }
    set(0);
  });

  /* 5. Yakından bak: büyüteç + noktalar */
  $$('[data-vz]').forEach(root => {
    const box = root.querySelector('[data-vz-img]'), img = box && box.querySelector('img'), lens = root.querySelector('[data-vz-lens]');
    if (!img || !lens) return;
    const sec = root.closest('.vz'), lis = $$('[data-vz-li]', sec), hots = $$('[data-vz-hot]', root);
    const Z = 2.6;
    const place = (px, py) => {
      const r = box.getBoundingClientRect();
      const x = Math.max(0, Math.min(r.width, px)), y = Math.max(0, Math.min(r.height, py));
      lens.style.left = x + 'px'; lens.style.top = y + 'px';
      lens.style.backgroundImage = `url("${img.currentSrc || img.src}")`;
      lens.style.backgroundSize = `${r.width * Z}px ${r.height * Z}px`;
      const lw = lens.offsetWidth / 2;
      lens.style.backgroundPosition = `${-(x * Z - lw)}px ${-(y * Z - lw)}px`;
    };
    const pick = n => {
      lis.forEach((l, k) => l.classList.toggle('is-on', k === n));
      hots.forEach((h, k) => h.classList.toggle('is-on', k === n));
      const h = hots[n]; if (!h) return;
      const r = box.getBoundingClientRect();
      box.classList.add('is-lens');
      place(parseFloat(h.style.left) / 100 * r.width, parseFloat(h.style.top) / 100 * r.height);
    };
    box.addEventListener('mousemove', e => { const r = box.getBoundingClientRect(); box.classList.add('is-lens'); place(e.clientX - r.left, e.clientY - r.top); });
    box.addEventListener('mouseleave', () => box.classList.remove('is-lens'));
    let held = false;
    box.addEventListener('touchstart', e => { held = true; const r = box.getBoundingClientRect(), t = e.touches[0]; box.classList.add('is-lens'); place(t.clientX - r.left, t.clientY - r.top); }, { passive: true });
    box.addEventListener('touchmove', e => { if (!held) return; const r = box.getBoundingClientRect(), t = e.touches[0]; place(t.clientX - r.left, t.clientY - r.top); }, { passive: true });
    box.addEventListener('touchend', () => { held = false; setTimeout(() => box.classList.remove('is-lens'), 900); });
    lis.forEach((l, k) => l.addEventListener('click', () => pick(k)));
    hots.forEach((h, k) => h.addEventListener('click', e => { e.stopPropagation(); pick(k); }));
  });

  /* 6. Gece mi Şafak mı — mobil sekmeler */
  $$('[data-vd]').forEach(root => {
    const tabs = $$('[data-vd-tab]', root), ps = $$('[data-vd-p]', root);
    tabs.forEach((t, k) => t.addEventListener('click', () => {
      tabs.forEach((x, j) => x.classList.toggle('is-on', j === k));
      ps.forEach((x, j) => x.classList.toggle('is-on', j === k));
    }));
  });

  /* 7. Hafif parallax (masaüstü) */
  if (!RM && matchMedia('(min-width: 990px)').matches) {
    const px = $$('.image-with-text__media img');
    const upd = () => px.forEach(im => {
      const r = im.parentElement.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return;
      const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      im.style.transform = `translateY(${p * -24}px) scale(1.06)`;
    });
    addEventListener('scroll', upd, { passive: true }); upd();
  }
})();

/* ============ v3.2 · heyecan katmanı ============ */
(() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Başlıkları kelime kelime aç */
  const heads = $$('main h2:not(.vh__t), .vs__ch h3, .vd__n');
  const sio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); sio.unobserve(e.target); } }), { threshold: .2 });
  heads.forEach(h => {
    if (RM || h.dataset.vsplit || h.querySelector('*:not(br):not(em):not(span)')) return;
    const words = h.textContent.trim().split(/\s+/); if (!words.length) return;
    h.dataset.vsplit = 1; h.setAttribute('aria-label', h.textContent.trim());
    h.innerHTML = words.map((w, i) => `<span class="v-w" aria-hidden="true"><span style="--i:${i}">${w.replace(/</g, '&lt;')}</span></span>`).join(' ');
    h.classList.add('v-split'); sio.observe(h);
  });

  /* Butonlara ok + 3D eğim (masaüstü) */
  $$('.vh .button--primary, .v-step ~ div .button, .vz ~ * .button--primary').forEach(b => { if (!b.querySelector('.v-arw')) b.insertAdjacentHTML('beforeend', '<span class="v-arw" aria-hidden="true">→</span>'); });
  if (FINE && !RM) {
    $$('.button:not(.button--tertiary), .shopify-payment-button__button--unbranded').forEach(b => {
      b.addEventListener('mousemove', e => {
        const r = b.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        b.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg'); b.style.setProperty('--rx', (-y * 18).toFixed(2) + 'deg');
      });
      b.addEventListener('mouseleave', () => { b.style.setProperty('--ry', '0deg'); b.style.setProperty('--rx', '0deg'); });
    });
    /* Kartlarda 3D eğim + parlama */
    $$('.v-why__c, .v-tile, .v-step, .multicolumn-card, .featured-product .product__media-item').forEach(c => {
      c.classList.add('v-tilt'); if (!c.querySelector('.v-glare')) c.insertAdjacentHTML('beforeend', '<span class="v-glare"></span>');
      c.addEventListener('mousemove', e => {
        const r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        c.classList.add('is-tilting');
        c.style.setProperty('--ty', ((x - .5) * 10).toFixed(2) + 'deg'); c.style.setProperty('--tx', ((.5 - y) * 10).toFixed(2) + 'deg');
        c.style.setProperty('--gx', x * 100 + '%'); c.style.setProperty('--gy', y * 100 + '%');
      });
      c.addEventListener('mouseleave', () => { c.classList.remove('is-tilting'); c.style.setProperty('--ty', '0deg'); c.style.setProperty('--tx', '0deg'); });
    });
  }

  /* Dev bant: kaydırma hızına bağlı akış */
  const rows = $$('[data-vbm-row]');
  if (rows.length && !RM) {
    let x = 0, last = scrollY, v = 0;
    const loop = () => {
      const s = scrollY; v = v * .9 + (s - last) * .1; last = s;
      x -= .6 + Math.abs(v) * .25;
      rows.forEach((r, i) => {
        const t = r.firstElementChild, w = t.scrollWidth / 2;
        const dir = r.classList.contains('vbm__row--rev') ? -1 : 1;
        const off = ((x * dir) % w + w) % w;
        t.style.transform = `translateX(${-off}px)`;
      });
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  /* Üst ilerleme çizgisi */
  const bar = document.createElement('div'); bar.className = 'v-progress'; document.body.appendChild(bar);
  const up = () => { const h = document.documentElement.scrollHeight - innerHeight; bar.style.transform = `scaleX(${h > 0 ? scrollY / h : 0})`; };
  addEventListener('scroll', up, { passive: true }); up();

  /* Sepete ekleyince buton zıplasın */
  document.addEventListener('submit', e => {
    const b = e.target.querySelector && e.target.querySelector('.product-form__submit'); if (!b || RM) return;
    b.animate([{ transform: 'scale(1)' }, { transform: 'scale(.94)' }, { transform: 'scale(1.04)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'cubic-bezier(.2,.7,.2,1)' });
  }, true);
})();

/* ============ v3.4 · renk galerisi + kapıda öde + parlak butonlar ============ */
(() => {
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const COLORS = ['Gece', 'Şafak'];
  const colorOf = root => {
    const fs = $$('fieldset', root).find(f => /Renk/i.test((f.querySelector('legend') || {}).textContent || ''));
    const c = fs && fs.querySelector('input:checked'); if (c) return c.value;
    const sel = $$('select', root).find(s => /Renk/i.test(s.name || '')); return sel ? sel.value : null;
  };
  const scopeOf = el => el.closest('product-info, .product, section') || document;

  /* 1. Galeriyi seçilen renge göre süz — CSS + gözlemci, zamanlamadan bağımsız */
  const KEY = { 'Gece': 'gece', 'Şafak': 'safak' };
  const colorOf2 = root => {
    try {
      const js = root.querySelector('variant-selects [data-selected-variant]');
      if (js) { const v = JSON.parse(js.textContent); const o = (v && v.options || []).find(x => KEY[x]); if (o) return o; }
    } catch (e) {}
    return colorOf(root);
  };
  const tag = root => $$('.product__media-item, .thumbnail-list__item', root).forEach(li => {
    const alt = ((li.querySelector('img') || {}).alt || '') + ' ' + (li.getAttribute('aria-label') || '');
    const c = COLORS.filter(x => alt.includes(x)); li.dataset.vc = c.length === 1 ? KEY[c[0]] : 'all';
  });
  const sync = root => {
    const col = colorOf2(root); if (!col || !KEY[col]) return;
    tag(root);
    const k = KEY[col], was = root.dataset.vCol; root.dataset.vCol = k;
    const isHidden = li => li.dataset.vc !== 'all' && li.dataset.vc !== k;
    const items = $$('.product__media-item', root);
    const active = items.find(li => li.classList.contains('is-active'));
    if (!active || isHidden(active)) {
      const first = items.find(li => !isHidden(li));
      if (first) {
        items.forEach(li => li.classList.remove('is-active')); first.classList.add('is-active');
        const list = first.parentElement; if (list && list.scrollTo) list.scrollTo({ left: first.offsetLeft - list.offsetLeft, behavior: 'instant' });
      }
    }
    if (was !== k && matchMedia('(max-width: 749px)').matches) {
      $$('slider-component', root).forEach(sl => { try { const n = $$('[id^="Slide-"]', sl).filter(x => x.clientWidth > 0).length; if (n > 1 && sl.resetPages) sl.resetPages(); } catch (e) {} });
    }
  };
  const roots = () => $$('product-info');
  roots().forEach(r => {
    let q = 0; const run = () => { if (q) return; q = requestAnimationFrame(() => { q = 0; sync(r); }); };
    new MutationObserver(run).observe(r, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked'] });
    r.addEventListener('change', run); r.addEventListener('click', () => setTimeout(run, 30));
    sync(r); setTimeout(() => sync(r), 600);
  });
  const scopeOfBtn = el => el.closest('product-info') || scopeOf(el);
  document.addEventListener('change', e => {
    if (!e.target.matches('input[type=radio], select')) return;
    if (/Beden/i.test(((e.target.closest('fieldset') || {}).querySelector?.('legend') || {}).textContent || e.target.name || '')) {
      const sc = scopeOfBtn(e.target); sc.dataset.vSize = '1'; const h = sc.querySelector('[data-v-cod-hint]'); h && (h.hidden = true);
    }
  });

  /* 2. Kapıda öde */
  const fmt = c => { const t = Math.round(c / 100); return t.toLocaleString('tr-TR') + ' TL'; };
  const ROOT = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  const variantData = sc => {
    const id = (sc.querySelector('form[action*="/cart/add"] input[name="id"]') || {}).value;
    const q = Math.max(1, parseInt((sc.querySelector('input[name="quantity"]') || {}).value || '1', 10));
    let v = null;
    try { const js = sc.querySelector('variant-selects script[type="application/json"], [data-selected-variant]'); if (js) { const d = JSON.parse(js.textContent); v = Array.isArray(d) ? d.find(x => String(x.id) === String(id)) : d; } } catch (e) {}
    const priceTxt = (sc.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular') || {}).textContent || '';
    const cents = v && v.price ? v.price : Math.round(parseFloat(priceTxt.replace(/[^\d,]/g, '').replace(/\./g, '').replace(',', '.')) * 100) || 0;
    const opts = $$('fieldset', sc).map(f => (f.querySelector('input:checked') || {}).value).filter(Boolean);
    const img = sc.querySelector('.product__media-item.is-active img') || sc.querySelector('.product__media-item img');
    return { id, q, cents, opts, label: opts.join(' · '), img: img ? (img.currentSrc || img.src) : '' };
  };

  /* 2a. İkili paket */
  const pairOf = sc => sc.querySelector('[data-v-pair]');
  const pairOn = sc => { const p = pairOf(sc); return !!(p && (p.querySelector('input[type=radio]:checked') || {}).value === '2'); };
  const variantsOf = sc => { try { return JSON.parse(pairOf(sc).querySelector('[data-v-variants]').textContent); } catch (e) { return []; } };
  const secondOf = sc => {
    const p = pairOf(sc); if (!p) return null;
    const vals = $$('[data-v-opt]', p).map(r => (r.querySelector('.v-chip.is-on') || {}).dataset?.vVal);
    if (vals.some(x => !x)) return null;
    return variantsOf(sc).find(v => v.o.every((x, i) => x === vals[i])) || null;
  };
  const syncSecond = (sc, force) => {
    const p = pairOf(sc); if (!p) return;
    const d = variantData(sc);
    $$('[data-v-opt]', p).forEach((row, i) => {
      if (row.dataset.touched && !force) return;
      const want = d.opts[i]; $$('.v-chip', row).forEach(c => c.classList.toggle('is-on', c.dataset.vVal === want));
    });
    // stokta olmayan kombinasyonları soluklaştır
    const vs = variantsOf(sc); const cur = $$('[data-v-opt]', p).map(r => (r.querySelector('.v-chip.is-on') || {}).dataset?.vVal);
    $$('[data-v-opt]', p).forEach((row, i) => $$('.v-chip', row).forEach(c => {
      const test = cur.slice(); test[i] = c.dataset.vVal; const v = vs.find(x => x.o.every((o, k) => o === test[k]));
      c.classList.toggle('is-off', !!v && !v.a);
    }));
  };
  const totalOf = (sc, d) => {
    const p = pairOf(sc); const pair = p ? +p.dataset.pair : 0;
    if (pairOn(sc)) return { n: 2, full: d.cents * 2, total: pair };
    const full = d.cents * d.q; const total = pair ? Math.floor(d.q / 2) * pair + (d.q % 2) * d.cents : full;
    return { n: d.q, full, total };
  };
  $$('[data-v-pair]').forEach(p => {
    const sc = scopeOfBtn(p);
    const sec = p.querySelector('[data-v-second]');
    const apply = () => { const on = pairOn(sc); sec.hidden = !on; sc.dataset.vPm = on ? '2' : '1'; if (on) syncSecond(sc); };
    p.addEventListener('change', e => { if (e.target.name && e.target.name.startsWith('v-pair')) apply(); e.stopPropagation(); });
    p.addEventListener('click', e => {
      const c = e.target.closest('.v-chip'); if (!c) return;
      const row = c.closest('[data-v-opt]'); row.dataset.touched = '1';
      $$('.v-chip', row).forEach(x => x.classList.toggle('is-on', x === c)); syncSecond(sc);
    });
    sc.addEventListener('change', () => setTimeout(() => pairOn(sc) && syncSecond(sc), 60));
    apply();
  });
  const itemsOf = (sc, d) => {
    if (!pairOn(sc)) return [{ id: +d.id, quantity: d.q }];
    const s2 = secondOf(sc); if (!s2) return null;
    return String(s2.id) === String(d.id) ? [{ id: +d.id, quantity: 2 }] : [{ id: +d.id, quantity: 1 }, { id: s2.id, quantity: 1 }];
  };
  // "Sepete ekle" ikili pakette iki ürünü birlikte ekler
  document.addEventListener('click', e => {
    const b = e.target.closest('.product-form__submit'); if (!b) return;
    const sc = scopeOfBtn(b); if (!pairOn(sc)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const items = itemsOf(sc, variantData(sc)); if (!items) return;
    b.classList.add('loading'); b.setAttribute('aria-disabled', 'true');
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
      .then(r => r.json()).then(() => { location.href = ROOT + 'cart'; }).catch(() => { b.classList.remove('loading'); b.removeAttribute('aria-disabled'); });
  }, true);

  $$('[data-v-cod]').forEach(btn => {
    const sc = scopeOfBtn(btn); const sheet = sc.querySelector('[data-v-sheet]') || btn.parentElement.nextElementSibling;
    btn.addEventListener('click', () => {
      const hasSize = $$('fieldset', sc).some(f => /Beden/i.test((f.querySelector('legend') || {}).textContent || ''));
      if (hasSize && !sc.dataset.vSize) {
        const fs = $$('fieldset', sc).find(f => /Beden/i.test((f.querySelector('legend') || {}).textContent || ''));
        const h = sc.querySelector('[data-v-cod-hint]'); if (h) h.hidden = false;
        if (fs) { fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); fs.classList.remove('v-shake'); void fs.offsetWidth; fs.classList.add('v-shake'); }
        return;
      }
      const d = variantData(sc); if (!d.id || !sheet) return;
      const items = itemsOf(sc, d); if (!items) return;
      const t = totalOf(sc, d); const s2 = pairOn(sc) ? secondOf(sc) : null;
      sheet.querySelector('[data-s-img]').src = d.img;
      sheet.querySelector('[data-s-var]').textContent = d.label + ' beden' + (s2 ? '  +  ' + s2.o.join(' · ') + ' beden' : '');
      sheet.querySelector('[data-s-qty]').textContent = '× ' + t.n;
      sheet.querySelector('[data-s-items]').textContent = fmt(t.full);
      const dr = sheet.querySelector('[data-s-disc-row]'); if (dr) { dr.hidden = t.full === t.total; sheet.querySelector('[data-s-disc]').textContent = '−' + fmt(t.full - t.total); }
      sheet.querySelector('[data-s-total]').textContent = fmt(t.total);
      sheet._items = items; sheet.showModal ? sheet.showModal() : sheet.setAttribute('open', '');
    });
    if (sheet && !sheet._bound) {
      sheet._bound = 1;
      sheet.addEventListener('click', e => { if (e.target === sheet || e.target.closest('[data-v-sheet-x]')) sheet.close(); });
      sheet.querySelector('[data-v-sheet-go]').addEventListener('click', function () {
        const it = sheet._items; if (!it) return; this.classList.add('is-busy'); this.disabled = true;
        location.href = ROOT + 'cart/' + it.map(x => x.id + ':' + x.quantity).join(',');
      });
    }
  });

  /* 3. Butonlara dalga efekti */
  document.addEventListener('pointerdown', e => {
    const b = e.target.closest('.button, .v-cod, .shopify-payment-button__button'); if (!b || RM) return;
    const r = b.getBoundingClientRect(); const s = document.createElement('span'); s.className = 'v-ripple';
    const d = Math.max(r.width, r.height) * 2; s.style.cssText = `width:${d}px;height:${d}px;left:${e.clientX - r.left - d / 2}px;top:${e.clientY - r.top - d / 2}px`;
    b.appendChild(s); setTimeout(() => s.remove(), 700);
  });

  /* 4. Ürün sayfasında "Bedenimi seç" → beden alanına kaydır */
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-v-to-size]'); if (!a) return;
    const fs = $$('product-info fieldset').find(f => /Beden/i.test((f.querySelector('legend') || {}).textContent || ''));
    if (!fs) return; e.preventDefault(); fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => { fs.classList.remove('v-shake'); void fs.offsetWidth; fs.classList.add('v-shake'); }, 500);
  });
})();
